import { gql } from '@apollo/client';

export const ADMIN_LIST_USERS = gql(`
  query AdminListUsers {
    adminListUsers {
      items {
        username
        email
        markEmailVerified
        displayName
        givenName
        familyName
        enabled
        confirmStatus
        trialEndsAt
        billingStatus
        currentPeriodEndAt
        cancelAtPeriodEnd
        billingCustomerExternalId
        billingSubscriptionExternalId
        createdAt
        lastModifiedAt
        lastSeenAt
      }
      nextToken
    }
  }
`);

export const ADMIN_ENABLE_USER = gql(`
  mutation AdminEnableUser($username: String!) {
    adminEnableUser(username: $username)
  }
`);

export const ADMIN_DISABLE_USER = gql(`
  mutation AdminDisableUser($username: String!) {
    adminDisableUser(username: $username)
  }
`);

export const ADMIN_RESET_USER_PASSWORD = gql(`
  mutation AdminResetUserPassword($username: String!) {
    adminResetUserPassword(username: $username)
  }
`);

export const ADMIN_CREATE_USER = gql(`
  mutation AdminCreateUser($email: String!, $sendInvite: Boolean, $markEmailVerified: Boolean, $enableTrial: Boolean, $displayName: String, $familyName: String, $givenName: String) {
    adminCreateUser(email: $email, displayName: $displayName, sendInvite: $sendInvite, markEmailVerified: $markEmailVerified, enableTrial: $enableTrial, familyName: $familyName, givenName: $givenName) {
      username
    }
  }
`);

export const ADMIN_UPDATE_USER_ATTRIBUTES = gql(`
  mutation AdminUpdateUserAttributes($username: String!, $displayName: String, $familyName: String, $givenName: String) {
    adminUpdateUserAttributes(
      username: $username
      displayName: $displayName
      familyName: $familyName
      givenName: $givenName
    ) {
      username
    }
  }
`);
